import React from 'react';
import ids from '../../utils/constants/ids';
import codes from '../../utils/constants/codes';
import GenericFormWithChildQuestions from '../genericFormWithChildrenQuestions/genericFormWithChildQuestion';
import { ObjectOfStrings, QuestionSchema } from '../../reducers/types';
import GenericParentQuestion from '../genericFormWithChildrenQuestions/genericParentQuestion';
import { FormikProps } from 'formik';

type Props = {
    questions: QuestionSchema[];
    formikProps: FormikProps<any>;
    questionTypes: ObjectOfStrings;
};

const EditableQuestionsWithAnswer = (props: Props) => {
    const { questions, formikProps, questionTypes } = props;

    return (
        <>
            <GenericFormWithChildQuestions>
                {questions.map(
                    (
                        question: QuestionSchema | any,
                        index: number,
                        accQuestions: QuestionSchema[],
                    ) => {
                        return (
                            <GenericFormWithChildQuestions.ParentElement
                                key={question.id}
                            >
                                <>
                                    <GenericParentQuestion.Form
                                        key={question.id}
                                        index={index}
                                        question={question}
                                        accQuestions={accQuestions}
                                        questionTypes={questionTypes}
                                        hasHorizontalRule={false}
                                        defaultLabelSize={
                                            question.questionGroupStepId ===
                                            ids.declarationQuestionGroupStep
                                                ? 'col-sm-7'
                                                : 'col-sm-5'
                                        }
                                        defaultInputSize={
                                            question.questionGroupStepId ===
                                            ids.declarationQuestionGroupStep
                                                ? 'col-sm-4'
                                                : 'col-sm-6'
                                        }
                                        notUseFieldValidator={false}
                                        formikProps={formikProps}
                                        isReadOnlyOrEditableQuestion={
                                            codes.isReadOnly
                                        }
                                        inlineReadOnlyElement={
                                            <GenericParentQuestion.ReadOnlyForm
                                                questionTypeCode={
                                                    question[
                                                        '_questionTypeCode'
                                                    ]
                                                }
                                                value={
                                                    formikProps.values[
                                                        question.code
                                                    ]
                                                }
                                                options={question.options}
                                            ></GenericParentQuestion.ReadOnlyForm>
                                        }
                                    />
                                </>
                            </GenericFormWithChildQuestions.ParentElement>
                        );
                    },
                )}
            </GenericFormWithChildQuestions>
        </>
    );
};

export default EditableQuestionsWithAnswer;
